import styled from 'styled-components';
import { Label } from '../../Label/Label';
import { getPaletteColor } from '../../utils/utils';
import { ChipContentWrapper } from '../ChipContentWrapper';
export const ChipLabel = /*#__PURE__*/styled(Label).withConfig({
  displayName: "ChipLabel",
  componentId: "sc-sqns6s-0"
})(["display:inline-flex;user-select:none;padding:0;margin:0;> input:focus-visible ~ ", "{border-color:", ";outline-offset:2px;outline:3px solid ", ";}"], ChipContentWrapper, getPaletteColor('base'), getPaletteColor('base'));